import store from 'store'
import { map, toLower } from 'lodash'

const OUTLETS_STORE_KEY = 'savorOutlets'
function combineOutlet(outlet) {
  const toLowerCode = toLower(outlet.code)
  const combineOutlet = {
    code: outlet.code,
    name: outlet.name,
    _id: outlet._id,
    tabNamespaceString: `/${toLowerCode}`,
    receiptPrinterNamespaceString: `/${toLowerCode}/receipt-printer`,
    orderPrinterNamespaceString: `/${toLowerCode}/savor-printer`,
    labelPrinterNamespaceString: `/${toLowerCode}/label-printer`,
    mobileAppNamespaceString: `/${toLowerCode}/mobile-app`,
    products: [],
    tabNamespace: null,
    orderPrinterNamespace: null,
    labelPrinterNamespace: null,
    mobileAppNamespace: null,
    receiptPrinterNamespace: null,
    numLabelPrinters: 0,
    numOrderPrinters: 0,
    numMobileApps: 0,
    numReceiptPrinters: 0
  }
  return combineOutlet
}
let outlets

// Danh sách cơ sở được server trả về ở bước xác thực và lưu lại ở đây, vì route /outlets
// của 4handy-work yêu cầu đăng nhập nên không gọi trực tiếp từ POS được nữa.
export const setOutlets = function(rawOutlets) {
  store.set(OUTLETS_STORE_KEY, rawOutlets || [])
  outlets = map(rawOutlets, outlet => combineOutlet(outlet))
}

export const clearOutlets = function() {
  store.remove(OUTLETS_STORE_KEY)
  outlets = null
}

export const getOutlets = async function() {
  if (!outlets) {
    outlets = map(store.get(OUTLETS_STORE_KEY) || [], outlet => combineOutlet(outlet))
  }
  return outlets
}
